
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

export default {
name: 'Matrix',
data () {
return {
index: 0
}
},
watch: {

},
components: {
Tabbar,
TabbarItem
}
}
